import { render, staticRenderFns } from "./facus.vue?vue&type=template&id=98634ad8&scoped=true&"
import script from "./facus.vue?vue&type=script&lang=js&"
export * from "./facus.vue?vue&type=script&lang=js&"
import style0 from "./facus.vue?vue&type=style&index=0&id=98634ad8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98634ad8",
  null
  
)

export default component.exports